module.exports = __webpack_public_path__ + "static/media/nazka-team-1_thumb.64ea59be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/nazka-team-1_thumb.jpg
// module id = 291
// module chunks = 0